import { NgModule } from '@angular/core';
import { EuiTableModule } from '@eui/components/eui-table';

@NgModule({
  exports: [EuiTableModule],
  imports: [EuiTableModule],
})
export class EuiModules {}
